import { ACTION } from '@/store/ACTION';

class SetFreeRoundsData {
  protected allowed(): boolean {
    return (
      this.store.promo.hasPromoApp() &&
      this.store.promo.isFreeRounds &&
      !this.store.gameData.freeSpinsGame.isPlaying() &&
      !this.store.gameData.bonusGame.isPlaying()
    );
  }

  execution(): void {
    if (!this.allowed()) return;

    promoApp.eventEmitter.emit(ACTION.SET_FREE_ROUNDS_DATA, {
      ...this.store.promo.freeRounds,
      currency: this.store.currency,
      currencyDecimals: this.store.currencyDecimal
    });
  }

  get store() {
    return game.store;
  }
}

export { SetFreeRoundsData };
